import { useNavigate } from 'react-router-dom'


// styles and images 
import './Dashboard.css'
import '../../components/Components.css'

export default function ProjectListAlt({projectDocs}) {
    const navigate = useNavigate()
    
    const handleClick = (id) => {
        navigate(`/project/${id}`)
    }

    const handleArchive = (archived) => {
        if (archived) {
            return 'Yes'
        } else {
            return 'No'
        }
    }
  return (
    <div className='display-list'>
        <table className='table table-sm table-hover'>
            <thead>
                <tr>
                    <th>Job Name</th>
                    <th>Customer</th>
                    <th>Vendor</th>
                    <th>Archived</th>
                </tr>
            </thead>
            <tbody>
                {(projectDocs) && projectDocs.map(project => (
                        <tr onClick={() => handleClick(project.id)} style={{cursor: 'pointer'}} key={project.id}>
                            <td>{project.job_name}</td>
                            <td>{project.customer_name}</td>
                            <td>{project.vendor_name}</td>
                            <td>{handleArchive(project.archived)}</td>
                        </tr>
                ))} 
            </tbody>
        </table>
    </div>
  )
}
